import { Pencil } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgPencil1 = mkIcon(Pencil);